import {useEffect,useState} from 'react';

// Keep the sticky header's document space; only its top offset changes.
// This avoids moving the page underneath the user's finger.
export default function useScrollHeader(headerRef,section){
 const [hidden,setHidden]=useState(false);
 useEffect(()=>{
  let frame=null,hiddenNow=false,distance=0,direction=0,width=window.innerWidth;
  const mobile=()=>window.innerWidth<=1100;
  const scrollY=()=>{
   const max=Math.max(0,Math.max(document.documentElement.scrollHeight,document.body.scrollHeight)-window.innerHeight);
   return Math.max(0,Math.min(window.scrollY||0,max)); // Ignore iOS rubber-band overscroll.
  };
  let last=scrollY();
  setHidden(false);
  const show=value=>{if(hiddenNow!==value){hiddenNow=value;setHidden(value);}};
  const reset=()=>{distance=0;direction=0;last=scrollY();show(false);};
  function update(){
   frame=null;
   const header=headerRef.current,y=scrollY(),delta=y-last;last=y;
   const focus=document.activeElement;
   const interacting=header?.querySelector('[aria-expanded="true"]')||(header?.contains(focus)&&focus?.matches('input,textarea,select,:focus-visible'));
   if(!mobile()||y<=Math.max(24,header?.getBoundingClientRect().height||100)||interacting){reset();return;}
   if(!delta)return;
   const nextDirection=delta>0?1:-1;
   if(nextDirection!==direction){direction=nextDirection;distance=0;}
   distance+=Math.abs(delta);
   // Require deliberate movement, and reveal sooner than we hide.
   if(distance>=(direction>0?20:8)){show(direction>0);distance=0;}
  }
  const scroll=()=>{if(frame===null)frame=window.requestAnimationFrame(update);};
  const resize=()=>{if(window.innerWidth!==width){width=window.innerWidth;reset();}};
  const header=headerRef.current;
  window.addEventListener('scroll',scroll,{passive:true});
  window.addEventListener('resize',resize);
  header?.addEventListener('focusin',reset);
  return()=>{if(frame!==null)window.cancelAnimationFrame(frame);window.removeEventListener('scroll',scroll);window.removeEventListener('resize',resize);header?.removeEventListener('focusin',reset);};
 },[headerRef,section]);
 return hidden;
}
